enum SettingType {
  GENERAL = 'general',
  CANDIDATE = 'candidate',
  ENTERPRISE = 'enterprise',
  CREDIT = 'credit',
}

export default SettingType;
